<p-confirm-dialog [draggable]="false" />
<mon-page-layout
    [header]="'adminAuditLog.page.header' | transloco"
    [subheader]="'adminAuditLog.page.subHeader' | transloco">
    <div class="tw-flex tw-flex-col tw-justify-between">
        <h2 class="filter-heading tw-mt-0 tw-mb-1">{{ 'adminAuditLog.page.filter' | transloco }}</h2>
        <div class="tw-flex tw-flex-wrap tw-gap-4">
            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-60">
                <label for="domain">{{ 'adminAuditLog.filter.label.domain' | transloco }}</label>
                <p-select inputId="domain"
                    [options]="domains"
                    optionLabel="name"
                    [(ngModel)]="domainIdModel"
                    [loading]="domainsLoading"
                    [placeholder]="domainsLoading ? ( 'select.loading.placeholder' | transloco ) : ( 'adminAuditLog.filter.placeholder.domain' | transloco )"
                    [disabled]="domainsLoading"
                    data-test="admin-audit-log-domain-select"
                    editable="true"
                    showClear="true"
                    (onChange)="onDomainChange($event.value)"
                    (onClear)="onDomainChange(null)"
                    appendTo="body" />
            </div>
            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-60">
                <label for="user">{{ 'adminAuditLog.filter.label.user' | transloco }}</label>
                <p-select inputId="user"
                    [options]="users"
                    optionLabel="name"
                    [(ngModel)]="userIdModel"
                    [placeholder]="'adminAuditLog.filter.placeholder.user' | transloco"
                    data-test="admin-audit-log-user-select"
                    editable="true"
                    showClear="true"
                    appendTo="body" />
            </div>
            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-60">
                <label for="module">{{ 'adminAuditLog.filter.label.module' | transloco }}</label>
                <p-select inputId="feature"
                    [options]="modules"
                    optionLabel="name"
                    [(ngModel)]="moduleModel"
                    [placeholder]="'adminAuditLog.filter.placeholder.module' | transloco"
                    data-test="admin-audit-log-module-select"
                    editable="true"
                    showClear="true"
                    appendTo="body" />
            </div>
            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-60">
                <label for="date">{{ 'adminAuditLog.filter.label.date' | transloco }}</label>
                <p-datepicker inputId="date"
                    fluid="true"
                    [(ngModel)]="dateRange"
                    showIcon="true"
                    icon="pi pi-chevron-down"
                    monthNavigator="true"
                    yearNavigator="true"
                    selectionMode="range"
                    showButtonBar="true"
                    todayButtonStyleClass="tw-hidden"
                    [maxDate]="maxDate"
                    dateFormat="dd-mm-yy"
                    placeholder="DD-MM-YYYY"
                    data-test="admin-audit-log-date-picker"
                    readonlyInput="true"
                    appendTo="body" />
            </div>
            <div class="tw-flex tw-items-end">
                <p-button data-test="admin-audit-log-apply-filters-button"
                    [label]="'adminAuditLog.filter.button.apply' | transloco"
                    (click)="applyFilters()"
                    (keydown.enter)="applyFilters()" />
            </div>
            <div class="tw-flex tw-items-end">
                <p-button data-test="admin-audit-log-export-button"
                    class="tw-flex"
                    variant="outlined"
                    [label]="'admin.auditLog.page.exportBtn.label' | transloco"
                    (onClick)="openCreateExport()">
                    <span class="material-icons-outlined tw-text-base/[1]" aria-hidden="true">output</span>
                </p-button>
            </div>
        </div>
    </div>

    <mon-table-wrapper
            [value]="logs"
            [headers]="[
                TABLE_SCHEMA.DATE,
                TABLE_SCHEMA.USER,
                TABLE_SCHEMA.DOMAIN,
                TABLE_SCHEMA.MODULE,
                TABLE_SCHEMA.TARGET,
                TABLE_SCHEMA.IDENTIFIER,
                TABLE_SCHEMA.ACTION
            ]"
            [total]="totalRecords"
            [currentPage]="currentPage"
            [perPage]="perPage"
            [loading]="loading"
            [sortBy]="sortBy"
            [sortDir]="sortDir || ''"
            [fixedTableLayout]="false"
            [emptyMessage]="'adminAuditLog.table.emptyMessage' | transloco"
            (page)="onPageChange($event)"
            (sort)="sortLogs($event)"
            tableKey="admin-audit-log"
            data-test="admin-audit-log-table">
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.DATE; let log">
            <span *ngIf="log.created_at" data-test="admin-audit-log-date-tableCell">
                {{ log.created_at | monUserDate:"D MMM YYYY" }}
            </span>
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.DOMAIN; let log">
            <span data-test="admin-audit-log-domain-tableCell">{{ log.domain?.title }}</span>
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.IDENTIFIER; let log">
            <div data-test="admin-audit-log-identifier-tableCell" class="table-identifier-col">
                <span *ngIf="log.data?.identifier" monFoldable>{{ log.data.identifier }}</span>
                <span *ngIf="!log.data?.identifier && log.data?.source_code" monFoldable>{{ log.data.source_code }}</span>
            </div>
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.ACTION; let log">
            <div class="tw-flex tw-justify-between tw-items-center" data-test="admin-audit-log-action">
                {{ log.action | underscoreless }}
                <div>
                    <span class="pi pi-info-circle cursor-pointer"
                        aria-hidden="true"
                        [pTooltip]="log.data?.comment"
                        tooltipTrigger="focus mouseenter"
                        tooltipPlacement="bottom-left"
                        *ngIf="log.data?.comment">
                    </span>
                    <p-button
                        data-test="admin-audit-log-actions-button"
                        [ariaLabel]="('adminAuditLog.table.action.openMenu' | transloco) + ' ' + log.id"
                        icon="pi pi-ellipsis-v"
                        [rounded]="true"
                        [text]="true"
                        (onClick)="menu.toggle($event)"
                        *ngIf="log.actionItems && log.actionItems.length > 0">
                    </p-button>
                    <p-menu data-test="admin-audit-log-actions-menu"
                        appendTo="body"
                        #menu
                        [popup]="true"
                        [model]="log.actionItems"
                        (onHide)="onMenuHide()">
                    </p-menu>
                </div>
            </div>
        </ng-container>
    </mon-table-wrapper>
</mon-page-layout>
